import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

export const DashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  border-left: 1px solid #c9cbcd;
  box-shadow:
    -2px 0 4px rgb(0 0 0 / 10%),
    0 2px 4px rgb(0 0 0 / 10%),
    0 -2px 4px rgb(0 0 0 / 10%),
    -2px 0 4px #f3f3f3;
`;

export const ContentWrapper = styled.div<{ width: number }>`
  margin-right: 5px;
  padding: 5px;
  width: ${({ width }) => width}%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    rgb(245 245 245 / 100%) 0%,
    rgb(244 251 242 / 100%) 50%,
    rgb(235 250 254 / 100%) 100%
  );
  position: relative;
`;
